import { render, staticRenderFns } from "./Grid23.vue?vue&type=template&id=74dba3a6&scoped=true&"
import script from "./Grid23.vue?vue&type=script&lang=ts&"
export * from "./Grid23.vue?vue&type=script&lang=ts&"
import style0 from "./Grid23.vue?vue&type=style&index=0&id=74dba3a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dba3a6",
  null
  
)

export default component.exports